import Home from "./Components/Pages/Home";
import MasterClientEdit from "./Components/Pages/MasterClientEdit";
import CRDEdit from "./Components/Pages/CRDEdit";
//import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import KataSlip from "./Components/Pages/KataSlip";
import { ToastContainer } from "react-toastify";
import KataSlipData from "./Components/Pages/KataSlipData";
import GatewayEntry from "./Components/Pages/GatewayEntry";
import QualityInbound from "./Components/Pages/QualityInbound";
import LabourInbound from "./Components/Pages/LabourInbound";
import Stacking from "./Components/Pages/Stacking";
import PasteControl from "./Components/Pages/PasteControl";
import PastControlReport from "./Components/Pages/PasteControlReport";
import CRD from "./Components/Pages/CRD";
import Login from "./Components/Pages/AdminLogin.jsx";
import Do from "./Components/Pages/Do";
import DoForm from "./Components/Pages/DoForm";
import LabourOutbound from "./Components/Pages/LabourOutbound";
import OutboundGateEntry from "./Components/Pages/OutboundGateEntry";
import QualityOutbound from "./Components/Pages/QualityOutbound";
import OutboundKataSlip from "./Components/Pages/OutboundKataSlip";
import OutboundKataSlipData from "./Components/Pages/OutboundKataSlipData";
import OutboundChallan from "./Components/Pages/OutboundChallan";
import { useContext, useEffect } from "react";
import { AuthContext } from "./Components/Auth/Authcontext";
import Dashboard from "./Components/Pages/Dashboard";
import DoForm2 from "./Components/Pages/DoForm2";
import ReportBilling from "./Components/Pages/ReportBilling";
import BillingDTR from "./Components/Pages/BillingDTR.jsx";
import Navbar from "./Components/Common/Navbar.jsx";
import Footer from "./Components/Common/Footer.jsx";
import CreateUser from "./Components/Pages/CreateUser.jsx";
import SelectLogin from "./Components/Pages/SelectLogin.jsx";
import AdminLogin from "./Components/Pages/AdminLogin.jsx";
import AppUserLogin from "./Components/Pages/AppUserLogin.jsx";
import QualityComparison from "./Components/Pages/QualityComparison.jsx";
import OrderProcess from "./Components/Pages/OrderProcess.jsx";
import CreateAdmin from "./Components/Pages/CreateAdmin.jsx";
import DeliveryOrderList from "./Components/Pages/DeliveryOrderList.jsx";
import MasterClientList from "./Components/Pages/MasterClientList.jsx";
import BillingForm from "./Components/Pages/BillingForm.jsx";
import KataSlipUpload from "./Components/Pages/Trial.jsx";
import Profile from "./Components/Pages/Profile.jsx";
import InvoiceTable from "./Components/Pages/InvoiceTable.jsx";
import Labour from "./Components/Pages/Labour.jsx";
import DeleteData from "./Components/Pages/deleteData/DeleteData.jsx";
import CRDList from "./Components/Pages/CRDList.jsx";
import CRDPrint from "./Components/Pages/CRDPrint.jsx";
import CddList from "./Components/Pages/CddList.jsx";
import CDDPrint from "./Components/Pages/CDDPrint.jsx";
import "./App.css"
import UpdateData from "./Components/Pages/updateData/UpdateData";
import CDDEdit from "./Components/Pages/CDDEdit";
import GateEntryEdit from "./Components/Pages/GateEntryEdit";
import KataSlipEdit from "./Components/Pages/KataSlipEdit";

const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) return;

    const excludedRoutes = [
      "/login",
      "/admin-login",
      "/app-user-login",
      "/dashboard",
      "/",
    ];

    if (excludedRoutes.includes(location.pathname)) return;

    fetch("https://irc.zentelex.com/api/workflow/update-session", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        lastRoute: location.pathname,
        interrupted: false,
      }),
    }).catch((err) => {
      console.error("Route tracking failed:", err);
    });
  }, [location]);

  return null;
};

const App = () => {
  const RoleProtectedRoute = ({ children, allowedRoles = [] }) => {
    const isLoggedIn = sessionStorage.getItem("token");
    const role = sessionStorage.getItem("role");

    if (!isLoggedIn) {
      return <Navigate to="/login" />;
    }

    // Prevent crash
    if (!allowedRoles.length) {
      console.error("allowedRoles not provided to RoleProtectedRoute");
      return <Navigate to="/dashboard" />;
    }

    if (!allowedRoles.includes(role)) {
      return <Navigate to="/dashboard" />;
    }

    return children;
  };

  return (
    <>
      <ToastContainer />
      <BrowserRouter>
       <RouteTracker />
        <Routes>
          <Route path="/login" element={<SelectLogin />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route path="/app-user-login" element={<AppUserLogin />} />
          <Route
            path="/dashboard"
            element={
              <RoleProtectedRoute
                allowedRoles={[
                  "Operations",
                  "Super_admin",
                  "QC",
                  "Accounts",
                  "admin",
                ]}
              >
                <Dashboard />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <RoleProtectedRoute>
                <Home />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/order-processing"
            element={
              <RoleProtectedRoute
                allowedRoles={["Operations", "Super_admin", "admin"]}
              >
                <OrderProcess />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/kata-slip"
            element={
              <RoleProtectedRoute
                allowedRoles={["Operations", "Super_admin", "admin"]}
              >
                <KataSlip />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/kata-slip-data"
            element={
              <RoleProtectedRoute
                allowedRoles={["Operations", "Super_admin", "admin"]}
              >
                <KataSlipData />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/gateway-entry"
            element={
              <RoleProtectedRoute
                allowedRoles={["Operations", "Super_admin", "admin"]}
              >
                <GatewayEntry />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/quality-inbound"
            element={
              <RoleProtectedRoute allowedRoles={["QC", "Super_admin", "admin"]}>
                <QualityInbound />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/labour-inbound"
            element={
              <RoleProtectedRoute allowedRoles={["Operations", "Super_admin"]}>
                <LabourInbound />
              </RoleProtectedRoute>
            }
          />
          <Route path="/stacking" element={<Stacking />} />

          <Route
            path="/paste-control"
            element={
              <RoleProtectedRoute
                allowedRoles={["Operations", "Super_admin", "admin"]}
              >
                <PasteControl />{" "}
              </RoleProtectedRoute>
            }
          />
          <Route path="/paste-control-report" element={<PastControlReport />} />

          <Route
            path="/commodity-received-document"
            element={
              <RoleProtectedRoute
                allowedRoles={["Operations", "Super_admin", "admin"]}
              >
                <CRD />{" "}
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/delivery-order"
            element={
              <RoleProtectedRoute
                allowedRoles={["Operations", "Super_admin", "admin"]}
              >
                <Do />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/labour"
            element={
              <RoleProtectedRoute allowedRoles={["Super_admin", "Accounts"]}>
                <Labour></Labour>
              </RoleProtectedRoute>
            }
          ></Route>
          <Route
            path="/superadmin/deliveryorderlist"
            element={
              <RoleProtectedRoute allowedRoles={["Super_admin"]}>
                <DeliveryOrderList />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/superadmin/masterclientlist"
            element={
              <RoleProtectedRoute allowedRoles={["Super_admin"]}>
                <MasterClientList />
              </RoleProtectedRoute>
            }
          />

          <Route path="/do-form" element={<DoForm />} />
          <Route
            path="/labour-outbound"
            element={
              <RoleProtectedRoute allowedRoles={["Operations", "Super_admin"]}>
                <LabourOutbound />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/outbound-gateway-entry"
            element={
              <RoleProtectedRoute
                allowedRoles={["Operations", "Super_admin", "admin"]}
              >
                <OutboundGateEntry />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/final-quality"
            element={
              <RoleProtectedRoute allowedRoles={["QC", "Super_admin", "admin"]}>
                <QualityOutbound />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/quality-comparison"
            element={
              <RoleProtectedRoute allowedRoles={["QC", "Super_admin", "admin"]}>
                <QualityComparison />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/final-kata-slip"
            element={
              <RoleProtectedRoute
                allowedRoles={["Operations", "Super_admin", "admin"]}
              >
                <OutboundKataSlip />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/outbound-kata-slip-data"
            element={
              <RoleProtectedRoute
                allowedRoles={["Operations", "Super_admin", "admin"]}
              >
                <OutboundKataSlipData />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/admin/createuser"
            element={
              <RoleProtectedRoute allowedRoles={["admin", "Super_admin"]}>
                <CreateUser />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/cdd-list"
            element={
              <RoleProtectedRoute
                allowedRoles={[
                  "Operations",
                  "Super_admin",
                  "QC",
                  "Accounts",
                  "admin",
                ]}
              >
                <CddList />
              </RoleProtectedRoute>
            }
          />
          <Route
            path="/crd-list"
            element={
              <RoleProtectedRoute
                allowedRoles={[
                  "Operations",
                  "Super_admin",
                  "QC",
                  "Accounts",
                  "admin",
                ]}
              >
                <CRDList />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/crd-print/:crdNo"
            element={
              <RoleProtectedRoute
                allowedRoles={[
                  "Operations",
                  "Super_admin",
                  "QC",
                  "Accounts",
                  "admin",
                ]}
              >
                <CRDPrint />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/cdd-print/:cddNo"
            element={
              <RoleProtectedRoute
                allowedRoles={[
                  "Operations",
                  "Super_admin",
                  "QC",
                  "Accounts",
                  "admin",
                ]}
              >
                <CDDPrint />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/superadmin/deletedata"
            element={
              <RoleProtectedRoute allowedRoles={["Super_admin"]}>
                <DeleteData />
              </RoleProtectedRoute>
            }
          />
          
        <Route
          path="/superadmin/updatedata"
          element={
          <RoleProtectedRoute allowedRoles={["Super_admin"]}>
          <UpdateData />
         </RoleProtectedRoute>
          }
         />
          
	  <Route
          path="/commodity-received-document/edit/:id"
         element={
           <RoleProtectedRoute
        allowedRoles={["Operations", "Super_admin", "admin"]}
         >
       <CRDEdit />
       </RoleProtectedRoute>
        }
        />
           
         <Route
          path="/master-client/edit/:id"
          element={
            <RoleProtectedRoute
             allowedRoles={["Operations", "Super_admin", "admin"]}
             >
           <MasterClientEdit />
           </RoleProtectedRoute>
           }
           />
           
           <Route
            path="/commodity-delivery-document/edit/:id"
             element={
             <RoleProtectedRoute allowedRoles={["admin", "Super_admin"]}>
             <CDDEdit />
            </RoleProtectedRoute>
                 }
             />
            
             

            <Route
              path="/gate-entry/edit/:id"
              element={
              <RoleProtectedRoute allowedRoles={["admin", "Super_admin"]}>
              <GateEntryEdit />
              </RoleProtectedRoute>
               }
             />

           <Route
            path="/kataslip/edit/:id"
            element={<KataSlipEdit />}
            />

          <Route
            path="/superadmin/create-admin"
            element={
              <RoleProtectedRoute allowedRoles={["Super_admin"]}>
                <CreateAdmin />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/accounts/billing"
            element={
              <RoleProtectedRoute allowedRoles={["Accounts", "Super_admin"]}>
                <BillingForm />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/do-form-2"
            element={
              <RoleProtectedRoute
                allowedRoles={["Operations", "Super_admin", "admin"]}
              >
                <DoForm2 />
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <RoleProtectedRoute
                allowedRoles={[
                  "Operations",
                  "Super_admin",
                  "QC",
                  "Accounts",
                  "admin",
                ]}
              >
                <Profile></Profile>
              </RoleProtectedRoute>
            }
          />

          <Route
            path="/alltransaction"
            element={<InvoiceTable></InvoiceTable>}
          />

          <Route path="/outbound-challan" element={<OutboundChallan />} />
          <Route path="/report-billing" element={<ReportBilling />} />
          <Route path="/pdfextract" element={<KataSlipUpload />} />

          <Route
            path="/billing-dtr"
            element={
              <RoleProtectedRoute>
                <BillingDTR />
              </RoleProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
